import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from '@/App'
import '@/index.css'

const container = document.getElementById('root')

// 🔴 조용히 넘어가지 않습니다. 마운트 지점이 없으면 그 자리에서 멈춥니다.
if (!container) {
  throw new Error(
    'index.html 에서 #root 요소를 찾지 못했습니다. 마운트할 지점이 없어 앱을 시작하지 못했습니다.',
  )
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
